window.addEventListener('load', function() {
    var logsContainer = document.querySelector('.logs-container');
    if (logsContainer) {
        var LogsViewer = require('../modules/LogsViewer');
        var m = new LogsViewer(logsContainer);
    }
});